var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"retrieve-pw-container-bg"},[_c('PassWordStep',{attrs:{"post":{ title: '设置密码' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }